<mat-card class="mat-elevation-z1">
    <p class="chart-title">Quantidade de atendimentos semanais:</p>
   <page-bar-chart [itens]="chartItens"></page-bar-chart>
</mat-card>
